// extracted by mini-css-extract-plugin
export default {"content":"bqa-z","title":"cqa-z","subTitle":"dqa-z","banner":"eqa-z","productCardOverride":"fqa-z"};